import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { CollectionAlbum } from '../collection-album.model';

@JsonObject('CollectionAlbumsResultsResponse')
export class CollectionAlbumsResultsResponse extends ApiResultsResponse<CollectionAlbum> {

  @JsonProperty('results', [CollectionAlbum])
  override results: CollectionAlbum[] = [];

  @JsonProperty('results_total', Number)
  resultsTotal: number = 0;
}
